import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full md:w-1/2 px-x3 md:p-0"
}
const _hoisted_2 = {
  key: 0,
  "aria-hidden": "true",
  class: "mt-x1 font-cormorant text-12 md:text-13 xl:text-16"
}

import { computed } from 'vue';
import { VendorInfoTileModel } from '@/types/B2CcontentServerContract';
import useVendorInfo from '@/shared/content/blocks/pdp/useVendorInfo';
import TextBlockHandler from '@/shared/content/blocks/helpers/TextBlockHandler.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import dictionaryService from '@/core/dictionary/dictionary.service';
import ResponsiveImage from '@/core/responsive/image/ResponsiveImage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VendorInfoTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
    content: VendorInfoTileModel,
}



const { getVendorInfo, vendor } = useVendorInfo(props.content.vendorId);
const aspectRatio = { xs: 1, sm: 4 / 3, default: 40 / 27 };
const labels = useBlockLabels();

const init = async() => {
    await getVendorInfo();
};

init();

const labelName = computed<{vendor: string}>(() => {
    return {
        vendor: vendor.value?.vendorTitle || vendor.value?.name,
    };
});

const textBlock = computed(() => {
    const label = dictionaryService.formatNamed(labels.producedByVendor, labelName.value);

    return {
        title: labels.producedByVendor ? label : vendor.value?.vendorTitle,
        text: vendor.value?.vendorDescription,
    };
});

const mediaBlock = computed(() => {
    return {
        media: props.content.media.mediaModel.model,
        text: props.content.media.mediaText,
        zoom: false,
    };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["flex flex-col-reverse items-center", __props.content.flipVendorDescriptionAndImage ? 'md:flex-row-reverse' : 'md:flex-row'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex md:w-1/2 px-x3 py-x5 md:py-0 items-center", {'mx-auto md:w-2/3' : !_unref(mediaBlock).media}])
    }, [
      (_unref(textBlock).text)
        ? (_openBlock(), _createBlock(TextBlockHandler, {
            key: 0,
            class: "lg:w-3/4 lg:m-auto",
            title: _unref(textBlock).title,
            text: _unref(textBlock).text
          }, null, 8, ["title", "text"]))
        : _createCommentVNode("", true)
    ], 2),
    (_unref(mediaBlock).media)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("figure", null, [
            _createVNode(ResponsiveImage, {
              "image-url": _unref(mediaBlock).media.url,
              "focus-points": _unref(mediaBlock).media.focusPoints,
              alt: _unref(mediaBlock).media.description,
              "aspect-ratio": aspectRatio
            }, null, 8, ["image-url", "focus-points", "alt"]),
            (_unref(mediaBlock).text)
              ? (_openBlock(), _createElementBlock("figcaption", _hoisted_2, _toDisplayString(_unref(mediaBlock).text), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})